module.exports = __webpack_public_path__ + "static/legendary-bce12f4e596248f1a39cedce18b2b709.png";